module.exports = __webpack_public_path__ + "img/cloud-raining-02.17715285.svg";